// src/styles/themes/theme.js
import { extendTheme } from '@chakra-ui/react';

const config = {
  initialColorMode: "light",
  useSystemColorMode: false,
};

const colors = {
  primary: {
    50: "#ECEFF1",
    100: "#CFD8DC",
    200: "#B0BEC5",
    300: "#90A4AE",
    400: "#78909C",
    500: "#607D8B",
    600: "#546E7A",
    700: "#455A64",
    800: "#37474F",
    900: "#263238"
  },
  brand: {
    500: "#fa1655", // Color principal del logo para los botones
  },
};

const styles = {
  global: (props) => ({
    body: {
      bg: "black",
      color: "white",
    },
  }),
};

const components = {
  Menu: {
    // En la versión actual, se definen los parts: "button", "list" (el contenedor desplegable) e "item"
    parts: ["button", "list", "item"],
    baseStyle: {
      list: {
        borderRadius: "md", // Bordes redondeados en el contenedor del submenú
      },
      item: {
        _hover: {
          bg: "gray.700",   // Fondo sutil al pasar el mouse sobre el item
          boxShadow: "md",  // Sombreado ligero
        },
      },
    },
  },
  Button: {
    defaultProps: {
      colorScheme: 'brand', // Hace que los botones usen el color del logo por defecto
    },
    variants: {
      solid: {
        bg: 'brand.500',
        color: 'white',
        _hover: {
          bg: '#c41244', // Un tono más oscuro que #fa1655
        },
        _active: {
          bg: '#a01038', // Aún más oscuro para el estado activo
        },
      },
    },
  },
};

const theme = extendTheme({ config, colors, styles, components });

export default theme;
